import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Row, Col, Spin, message, Drawer, Pagination } from "antd";
import api from "../../services/api";
import ProductCard from "../../components/ProductCard";
import ProductDetailContent from "./ProductDetailContent";

export default function SearchResults() {
  const [params] = useSearchParams();
  const query = params.get("q");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const pageSize = 54;

  useEffect(() => {
    if (query && query.length >= 3) {
      loadProducts();
    }
  }, [query, page]); // 🔥 add page

  const loadProducts = async () => {
    try {
      setLoading(true);

      const res = await api.get("/products", {
        params: {
          search: query,
          page,
          limit: pageSize,
        },
      });

      setProducts(res.data.data || []);
      setTotal(res.data.total || 0);
    } catch {
      message.error("Search failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (query && query.length >= 3) {
      loadProducts();
    }
  }, [query]);

  const openDetail = (product) => {
    setSelectedProduct(product);
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
    setSelectedProduct(null);
  };

  return (
    <>
      <h2>Search Results for "{query}"</h2>

      {loading && products.length ? (
        <Spin />
      ) : (
        <Row gutter={[16, 16]}>
          {products.map((p) => (
            <Col key={p.id} xs={24} sm={12} md={8} lg={4}>
              <ProductCard
                product={p}
                onDetail={() => openDetail(p)}
                cartItems={cartItems}
              />
            </Col>
          ))}
        </Row>
      )}

      {!loading && products.length === 0 && <p>No products found</p>}

      <Pagination
        current={page}
        pageSize={pageSize}
        total={total}
        showSizeChanger
        onChange={(p) => setPage(p)}
        style={{ textAlign: "center", marginTop: 20 }}
      />

      {/* 🔥 Product Detail Drawer */}
      <Drawer
        width={750}
        open={drawerOpen}
        onClose={closeDrawer}
        destroyOnHidden
      >
        {selectedProduct && (
          <ProductDetailContent
            product={selectedProduct}
            allProducts={products}
            cartItems={cartItems}
          />
        )}
      </Drawer>
    </>
  );
}
